var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Spinner'),_c('SubHeaderBlock'),_c('div',{staticClass:"flex mt-3 info"},[(_vm.driver_data)?_c('InfoBlock'):_vm._e(),(_vm.driver_data)?_c('AnaliticsBlock'):_vm._e()],1),(_vm.driver_data)?_c('TableBlock',{staticClass:"table_block"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }